import { gql } from 'apollo-angular'

export default gql`
  mutation set_user_status($id: Int!, $status: String!) {
    update_user(where: { id: { _eq: $id } }, _set: { status: $status }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
